// Mirrors AdProduct enum + seeded BillingRate values from avocash-ads
// backend. Rates shown here are the display defaults (STANDARD tier) —
// actual billing always reads the live rate from
// GET /internal/v1/billing/rates at campaign creation time.

export const AD_PRODUCT_FAMILIES = [
  {
    family: 'ad.family.wallet',
    billingKind: 'WALLET',
    products: [
      {
        code: 'GROUP_ACTIVATION',
        label: 'ad.product.groupActivation',
        icon: 'speaker_2_fill',
        unit: 'ad.unit.perGroupActivated',
        rates: { ENTRY: 3000, STANDARD: 5500, PREMIUM: 8000 },
        desc: 'ad.product.groupActivationDesc',
      },
      {
        code: 'GROUP_ACTIVATION_REVSHARE',
        label: 'ad.product.groupActivationRevshare',
        icon: 'speaker_2_fill',
        unit: 'ad.unit.flatPlusPctBasket',
        rates: { STANDARD: 2000 },
        revenueSharePct: 3,
        desc: 'ad.product.groupActivationRevshareDesc',
      },
      {
        code: 'NATIVE_FEED_CPM',
        label: 'ad.product.nativeFeedCpm',
        icon: 'square_grid_2x2_fill',
        unit: 'ad.unit.perThousandImpressions',
        rates: { ENTRY: 200, STANDARD: 450, PREMIUM: 800 },
        desc: 'ad.product.nativeFeedCpmDesc',
      },
      {
        code: 'NATIVE_FEED_CPC',
        label: 'ad.product.nativeFeedCpc',
        icon: 'square_grid_2x2_fill',
        unit: 'ad.unit.perClick',
        rates: { ENTRY: 50, STANDARD: 80, PREMIUM: 150 },
        desc: 'ad.product.nativeFeedCpcDesc',
      },
      {
        code: 'EVENT_COSPONSORSHIP',
        label: 'ad.product.eventCosponsorship',
        icon: 'calendar_badge_plus',
        unit: 'ad.unit.perEvent',
        rates: { ENTRY: 10000, STANDARD: 20000, PREMIUM: 35000 },
        desc: 'ad.product.eventCosponsorshipDesc',
      },
      {
        code: 'ADMIN_ENDORSEMENT',
        label: 'ad.product.adminEndorsement',
        icon: 'person_badge_plus',
        unit: 'ad.unit.perPublishedPost',
        rates: { ENTRY: 15000, STANDARD: 25000, PREMIUM: 40000 },
        desc: 'ad.product.adminEndorsementDesc',
      },
    ],
  },
  {
    family: 'ad.family.invoice',
    billingKind: 'INVOICE',
    products: [
      {
        code: 'CATEGORY_PARTNER',
        label: 'ad.product.categoryPartner',
        icon: 'rosette',
        unit: 'ad.unit.perYearExclusive',
        rates: { ENTRY: 2000000, STANDARD: 5000000, PREMIUM: 10000000 },
        desc: 'ad.product.categoryPartnerDesc',
      },
      {
        code: 'GROUP_INTELLIGENCE',
        label: 'ad.product.groupIntelligence',
        icon: 'chart_bar_fill',
        unit: 'ad.unit.perMonth',
        rates: { ENTRY: 150000, STANDARD: 300000, PREMIUM: 500000 },
        desc: 'ad.product.groupIntelligenceDesc',
      },
    ],
  },
]

export const ALL_AD_PRODUCTS = AD_PRODUCT_FAMILIES.flatMap(f => f.products)

export function productMeta(code) {
  return ALL_AD_PRODUCTS.find(p => p.code === code) ?? null
}

export function billingKindFor(code) {
  return AD_PRODUCT_FAMILIES.find(f => f.products.some(p => p.code === code))?.billingKind
}

export function fmtCfa(n) {
  return `${Math.round(n).toLocaleString('fr-FR')} CFA`
}